import { render, staticRenderFns } from "./HeaderCollaboratorsComp.vue?vue&type=template&id=92b05bc4&scoped=true&"
import script from "./HeaderCollaboratorsComp.vue?vue&type=script&lang=js&"
export * from "./HeaderCollaboratorsComp.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCollaboratorsComp.vue?vue&type=style&index=0&id=92b05bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b05bc4",
  null
  
)

export default component.exports